import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label } from 'reactstrap';

interface EditFeaturesModalProps {
  isOpen: boolean;
  toggle: () => void;
  property: any;
  setProperty: (property: any) => void;
  onSave: (property: any) => Promise<void>;
}

const EditFeaturesModal: React.FC<EditFeaturesModalProps> = ({
  isOpen,
  toggle,
  property,
  setProperty,
  onSave,
}) => {
  const [localProperty, setLocalProperty] = useState(property);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLocalProperty(property);
  }, [property]);

  const handleChange = (field: string, value: any) => {
    setLocalProperty((prev: typeof property) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(localProperty);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Editar características</ModalHeader>
      <ModalBody>
        <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="checkbox"
              checked={!!localProperty.is_featured}
              onChange={e => handleChange('is_featured', e.target.checked)}
            />{' '}
            Es Destacado
          </Label>
        </FormGroup>
        <FormGroup className="mb-3">
          <Label>Tipo de propiedad</Label>
          <Input
            type="text"
            value={property?.propertyType?.name || ''}
            disabled
            readOnly
            style={{ background: '#f8f9fa', fontWeight: 500 }}
          />
        </FormGroup>
        <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="checkbox"
              checked={!!localProperty.is_furnished}
              onChange={e => handleChange('is_furnished', e.target.checked)}
            />{' '}
            Amueblado
          </Label>
        </FormGroup>
        <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="checkbox"
              checked={!!localProperty.pets_allowed}
              onChange={e => handleChange('pets_allowed', e.target.checked)}
            />{' '}
            Acepta mascotas
          </Label>
        </FormGroup>
        <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="checkbox"
              checked={!!localProperty.has_white_goods}
              onChange={e => handleChange('has_white_goods', e.target.checked)}
            />{' '}
            Contiene línea blanca
          </Label>
        </FormGroup>
        <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="checkbox"
              checked={!!localProperty.accept_airbnb}
              onChange={e => handleChange('accept_airbnb', e.target.checked)}
            />{' '}
            Acepta Airbnb
          </Label>
        </FormGroup>
                <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="checkbox"
              checked={!!localProperty.with_assessment}
              onChange={e => handleChange('with_assessment', e.target.checked)}
            />{' '}
            Con Avaluo
          </Label>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={saving}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Guardando...' : 'Guardar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditFeaturesModal;